/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "522")


  
    
export interface API47839Item {
  
  /** 花名 */
  userName?: string;
  
  /** 真名 */
  realName?: string;
  
  /** 部门 */
  orgName?: string;
  
  /** 用户编号 */
  userNo?: string;
  
  /** 岗位 */
  job?: string;
  
  /** 项目角色（10：项目负责人；20：项目助理；30：项目成员） */
  roleType?: number;
  
  /**  */
  roleTypeDesc?: string;
  
  /** 加入项目时间 */
  joinDate?: any;
  
  /** 头像 */
  avatar?: string;
  
  /** 权限 ,ProjectTeamAuthResp */
  authorizationResp?: any;
  
};
    
  



export interface API47839Req {
  
  /** 项目id */
  projectNo?: string;
    
  /** 查询关键字，花名 */
  keyword?: string;
    
  /**  */
  pageSize?: string;
    
  /**  */
  pageIndex?: string;
    
  /**  */
  rowId?: string;
    
  /**  */
  jumpType?: string;
    
  /**  */
  searchCount?: string;
    
  /**  */
  orderObjects?: string;
    
};



export interface API47839Res {
  /** T  */
  list?: API47839Item[];
  /**   */
  totalNumber?: any;
  /**   */
  totalPage?: any;
  /**   */
  rowId?: string;
  /**   */
  hasNext?: boolean;
  /**   */
  pageSize?: any;
  /**   */
  pageIndex?: any;
  
};


// 47839 项目成员分页查询

export interface IUseGetAPI47839Return {
  /** 项目成员分页查询: 接口请求状态 */
  isAPI47839Loading: boolean;
  /** 项目成员分页查询: 接口请求返回数据 */
  dataAPI47839: API47839Res;
  /**  项目成员分页查询: 接口数据请求方法 */
  fetchAPI47839Data:  (inputs: API47839Req, config?: YWRequestConfig) => Promise<API47839Res>;
  /** 项目成员分页查询: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI47839 = ():IUseGetAPI47839Return => {
  let isMount = true;
  const [isAPI47839Loading, setIsAPI47839Loading] = useState(false);
  const [dataAPI47839, setDataAPI47839] = useState<API47839Res>({} as API47839Res);
  const requestUrl = `${basePath}/corp-admin/project/team/page`;

  const fetchAPI47839Data = async (inputs: API47839Req, config?: YWRequestConfig): Promise<API47839Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API47839Req>) || {}) as API47839Req;
    
  
    if ( isMount ) {
      setIsAPI47839Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API47839Res>(`${basePath}/corp-admin/project/team/page?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI47839(res || {} as API47839Res);
        setIsAPI47839Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI47839Loading(false);
      }
      return false as unknown as API47839Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI47839Loading,
    dataAPI47839,
    fetchAPI47839Data,
    requestUrl,
  }
}

